// extracted by mini-css-extract-plugin
export var buttonContainer = "_6w-1";
export var fontSizeSelect = "_6w-3";
export var formatSelect = "_6w-2";
export var formats = "_6w-4";
export var hidden = "_6w-5";
export var icon = "_6w-6";
export var select = "_6w-0";